import React, { useEffect, useState } from 'react';
import styles from './../../recentCustomers.module.scss'
import { Badge, Table } from 'react-bootstrap';
import { DASHBOARD_LARGEST_SEATS } from '../../../../../../../Utils/GlobalConstants';
import { api } from '../../../../../../../Utils/API';
import loadingGif from "../../../../../../../Assets/Images/Animations/loading-management-console.gif";

const LargestCustomerBySeat = (props) => {
   
    const [data, setData] = useState([])                                     // for storing recent customers data
    const [loadingState, setLoadingState] = useState(true)                      // loading state           

    // Header Authorization for General API's
    const config = {
        headers: {
            "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
        },
    };

    // Function to call Recent customers data
    async function GetLargestSeats() {
        await api.get(`${DASHBOARD_LARGEST_SEATS}`, config)
            .then(resp => {
                setLoadingState(false);
                if (resp.status == 200) {
                    setData(resp.data);
                }
            })
            .catch(error => {
                if (error?.status == 401 || error?.response?.status == 401) {
                    props.Logout();
                }
                else {
                }
            });
    };

    //useEffect for calling get api on initial load
    useEffect(() => {
        GetLargestSeats();
    }, [])

  return (
    <div className={styles["recent-customers-data"]}>
       {data.length > 0 && !loadingState && 
                    <Table>
                        <thead>
                            <tr>
                                <th>Customers</th>
                                {<th className="text-center">Status</th>}

                            </tr>
                        </thead>
                        <tbody className={styles["recent-customers-tbody"]}>
                            {data.map((td) => {
                                return (
                                    <>
                                        <tr>
                                            <td className={`${styles['largest-seats-customername-td']}`}>
                                                <span title={td.customerName} className={`${styles['big-customer-name']}`}>{td.customerName}</span>
                                                </td>
                                            {<td className={`text-center ${styles['recent-customers-actions']}`}>
                                                <div className={`${styles['seat-status-container']}`}>
                                                    <div className={`${styles['seat-column']}`}>
                                                        <Badge title={"Active Seat : " + td.activeCount} pill bg="success" className={`${styles['badge-active']}`} >
                                                            {`${td.activeCount > 999 ? Math.floor(td.activeCount / 1000) + '..' : td.activeCount}`}
                                                        </Badge>
                                                    </div>
                                                    <div className={`pl-2 ${styles['seat-column']}`}>
                                                        <Badge title={"Suspended Seat : " + td.suspendedCount} pill bg="danger" className={`${styles['badge-suspended']}`}>
                                                            {`${td.suspendedCount > 999 ? Math.floor(td.suspendedCount / 1000) + '..' : td.suspendedCount}`}
                                                        </Badge>
                                                    </div>
                                                </div>
                                            </td>}
                                        </tr>
                                    </>
                                )
                            })
                            }
                        </tbody>
                    </Table>
                }
                {data.length < 1 && !loadingState &&
                    <div className={styles["recent-customers-loading-state"]}>
                        <p>No data to display</p>
                    </div>
                }
                {data.length < 1 && loadingState &&
                     <div className={styles["recent-customers-loading-state"]}>
                    <div className={styles["no-data-customers"]}><img className="management-console-loading-icon" src={loadingGif} /><p className="text-medium text-strong management-console-loading-text">Loading...</p></div>
                     </div>
                }
    </div>
  )
}

export default LargestCustomerBySeat
